import type React from "react";
import { useProgress } from "@/hooks/useProgress";
import { formatDate } from "@/utils/date";
import type { Goal } from "@/types/goal";

interface GoalProgressProps {
	goal: Goal;
}

const GoalProgress: React.FC<GoalProgressProps> = ({ goal }) => {
	const { progress, loading, error } = useProgress(goal.id);

	if (loading) return <p>読み込み中...</p>;
	if (error) return <p>エラーが発生しました: {error.message}</p>;

	// 最新の進捗率を計算
	const latestProgress =
		progress.length > 0
			? progress.sort(
					(a, b) =>
						new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
				)[0].progress
			: 0;

	return (
		<div>
			<div className="mb-4">
				<div className="flex justify-between items-center mb-1">
					<span>全体の進捗</span>
					<span>{latestProgress}%</span>
				</div>
				<div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
					<div
						className="bg-blue-600 h-2.5 rounded-full"
						style={{ width: `${latestProgress}%` }}
					/>
				</div>
			</div>
			<h3 className="text-lg font-semibold mb-2">進捗ログ</h3>
			{progress.length === 0 ? (
				<p className="text-gray-500">まだ進捗が記録されていません</p>
			) : (
				<ul className="space-y-2">
					{progress.map((log) => (
						<li key={log.id} className="text-sm">
							<div className="flex justify-between items-center">
								<div>
									<span className="font-semibold">
										{formatDate(log.createdAt)}
									</span>
									<span className="ml-2">進捗: {log.progress}%</span>
								</div>
								{log.note && <span className="text-gray-600">{log.note}</span>}
							</div>
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default GoalProgress;
